import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'
import useVenueEnabledFeaturePreviews, { VenueFeaturePreviews } from './use-venue-enabled-feature-previews'

const useIsVenueBrandingEnabled = () => {
  const location = useLocation()
  const query = parse(location.search) as { [key: string]: string }
  const { origin, venueId } = query

  const { enabledFeatures } = useVenueEnabledFeaturePreviews({ venueId })

  // No Eversports Branding => Venue is part of feature switch, AND is origin=widget
  // Later this will come from the backend - we will set up an extension, and see if the venue has this extension enabled
  const isVenueBrandingEnabled =
    origin === 'widget' && enabledFeatures.includes(VenueFeaturePreviews.HIDE_EVERSPORTS_BRANDING)

  return isVenueBrandingEnabled
}

export { useIsVenueBrandingEnabled }
